import {MouseToolType} from '../../../docViewerUtils';
import MenuWrapper from '../MenuWrapper/MenuWrapper';
import SelectionModeToggleButton from '../selection-mode-toggle-button/SelectionModeToggleButton';

export const AnnotationMenu = ({
  selectionMode,
  setSelectionMode,
  onFullPage,
  showWarning,
}: {
  selectionMode: string | null;
  setSelectionMode: React.Dispatch<React.SetStateAction<string | null>>;
  onFullPage: () => void;
  showWarning: boolean;
}) => {
  return (
    <MenuWrapper>
      <>
        <SelectionModeToggleButton
          text="Rectangle"
          isActive={selectionMode === MouseToolType.RectangleAnnotation}
          dataTestId="rectangle-annotation"
          disabled={showWarning}
          onClick={() => {
            setSelectionMode((prev) =>
              prev === MouseToolType.RectangleAnnotation
                ? null
                : MouseToolType.RectangleAnnotation
            );
          }}
        />
        <SelectionModeToggleButton
          text="This Page"
          isActive={false}
          dataTestId="full-page-annotation"
          disabled={showWarning}
          onClick={() => {
            setSelectionMode(null);
            onFullPage();
          }}
        />
      </>
    </MenuWrapper>
  );
};
